// ==========================================
// src/lib/supabase.js — V5 DEFINITIVO
// ✅ detectSessionInUrl: TRUE (Supabase processa hash automaticamente)
// ==========================================
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://zmsvjakcdczgxgjtydwx.supabase.co';

const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inptc3ZqYWtjZGN6Z3hnanR5ZHd4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcxMzc1MDUsImV4cCI6MjA5MjcxMzUwNX0.WV0b29-Tc3uTsNgB2M5XyCsO8phxXqKmMEL3S2HLrzw';

if (!supabaseKey) {
  console.error('❌ ERRO: VITE_SUPABASE_ANON_KEY não configurada!');
}

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // ✅ TRUE: Supabase processa hash automaticamente
    storageKey: 'borafrete-auth',
    storage: window.localStorage
  }
});

// ✅ Helper: Garante sessão viva antes de operações críticas
export const garantirSessao = async () => {
  let { data: { session }, error } = await supabase.auth.getSession();
  
  if (session?.user) {
    return { user: session.user, session };
  }
  
  console.log('🔄 Sessão ausente, tentando refresh...');
  const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();
  
  if (refreshData?.session?.user) {
    console.log('✅ Sessão recuperada via refresh!');
    return { user: refreshData.session.user, session: refreshData.session };
  }
  
  const raw = localStorage.getItem('borafrete-auth');
  if (raw) {
    try {
      const parsed = JSON.parse(raw);
      if (parsed.currentSession?.access_token && parsed.currentSession?.refresh_token) {
        const { data: setData } = await supabase.auth.setSession({
          access_token: parsed.currentSession.access_token,
          refresh_token: parsed.currentSession.refresh_token
        });
        if (setData?.session?.user) {
          console.log('✅ Sessão restaurada do localStorage!');
          return { user: setData.session.user, session: setData.session };
        }
      }
    } catch (e) {
      console.error('Erro ao restaurar do storage:', e);
    }
  }
  
  return { user: null, session: null, error: refreshError || error };
};

export const checkSupabaseConnection = async () => {
  try {
    const { data, error } = await supabase.from('empresas').select('count', { count: 'exact', head: true });
    if (error) {
      console.error('❌ Supabase erro:', error);
      return false;
    }
    console.log('✅ Supabase conectado');
    return true;
  } catch (error) {
    console.error('❌ Supabase erro:', error);
    return false;
  }
};

export default supabase;